import { useFormikContext } from 'formik';
import React from 'react';
import { useEdit } from '../../Services/EditContext';
import CharterRequestDetail from '../Editors/CharterRequestDetail';
import Tabs from 'react-bootstrap/Tabs'
import Tab from 'react-bootstrap/Tabs'
import CharterRequestBidHistory from '../EntityList/CharterRequestBidHistory';
import TimeLine from '../EntityList/TimeLine';
import { useHistory, useParams } from 'react-router-dom';


const CharterRequest = ({ route, changeCharter }) => {
    const { values } = useFormikContext();
    const [edit] = useEdit();
    const { list } = useParams();

    let history = useHistory();
    const { id } = values;

    const setActiveTab = (tab) => {
        const newRoute = route + '/' + values.id + '/' + tab;
        history.push(newRoute);
    }

    return values.status !== 'New' ? <Tabs mountOnEnter onSelect={setActiveTab} activeKey={list} style={{ height: '100%' }}>
        <Tab key={'Detail'} eventKey={'Detail'} title='Detail' >
            {!list || list === 'Detail' ? <CharterRequestDetail parentRoute={route} route={route + '/' + values.id + "/Detail"} /> : null}
        </Tab>

        {!edit && <Tab key={'Bids'} eventKey={'Bids'} title='Bids'  >
            {list === 'Bids' ? <CharterRequestBidHistory item={values} charterRequestId={id} route={route + '/' + values.id + "/Bids"} parentHeight={600} headerHeight={0} /> : null}
        </Tab>
        }
        {!edit && <Tab key={'Timeline'} eventKey={'Timeline'} title='Timeline' style={{ height: '600px' }} >
            {list === 'Timeline' ? <TimeLine supplierCol type={"CharterRequest"} item={values} route={route + '/' + values.id + "/Timeline"} parentHeight={600} headerHeight={0} /> : null}
        </Tab>
        }
    </Tabs >

        : <CharterRequestDetail changeCharter={changeCharter} />;

}
export default CharterRequest;